import { defineAction } from '~/prix'
import { z } from 'zod'
import semenStockFetchAction from './semenStockFetch.action.json' with { type: 'json' }
import { semenStockObject } from '../semenStockObject'
import { bullObject } from '~/packages/rural/bull/bullObject'

const semenStockFetchDefinition = defineAction({
  ...semenStockFetchAction,

  input: z.object({ id: semenStockObject.shape.id, includeDeleted: z.boolean().nullish() }),
  output: semenStockObject.extend({ bull: bullObject }),
})

export default semenStockFetchDefinition
